import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'

import Title from 'components/title'

import stepsStyles from './breadcrumb-style'

const Breadcrumb = props => {
  const classes = stepsStyles(props.theme)
  const stepNames = props.steps.map(step => step.name)
  const stepsOn = stepNames.filter(name => stepNames.indexOf(name) <= stepNames.indexOf(props.step))
  const isStepsSmall = props.steps.length > 3
  const i18nScope = props.i18nScope ? `${props.i18nScope}.` : ''

  return (
    <div className={classNames(classes.steps, { [classes.stepsSmall]: isStepsSmall })}>
      <div className={classes.stepNames}>
        {props.steps.map((step, index) =>
          <p
            className={classNames(classes.step, {
              [classes.stepOn]: stepsOn.indexOf(step.name) > -1,
              [classes.stepSmall]: isStepsSmall,
            })}
            style={{ width: `${100 / props.steps.length}%` }}
            key={step.name}
          >
            <span className={classes.stepNum}>{index + 1}</span>
            <span className={classes.stepName}>{props.t(`${i18nScope}${step.name}`)}</span>
          </p>
        )}
      </div>
      <div className={classes.stepTrack}>
        {props.steps.slice(1).map(step =>
          <span
            className={classNames(classes.stepTrackSegment, {
              [classes.stepTrackSegmentOn]: stepsOn.indexOf(step.name) > -1
            })}
            style={{ width: `${100 / props.steps.length}%` }}
            key={step.name}
          />
        )}
      </div>
      {props.showMobileName && props.step !== 'confirmation' && <Title className={classes.stepMobileName}>{props.t(`${i18nScope}${props.step}`)}</Title>}
    </div>
  )
}

Breadcrumb.propTypes = {
  steps: PropTypes.array.isRequired,
  step: PropTypes.string,
  i18nScope: PropTypes.string,
  showMobileName: PropTypes.bool,
}

Breadcrumb.defaultProps = {
  showMobileName: true,
}

export default compose(
  withTheme,
  withTranslation()
)(Breadcrumb)
